const { ccclass, property } = cc._decorator;
import MailView from "./mail_view"
import ModelData from "../../../public/model_data";
import AppData from "../../../public/const/app_data";
import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import ModuleManager from "../../../../framework/core/module_manager";
import Utility from "../../../../utility/utility";
import { GameManager } from "../../../../manager/game_manager";
import SceneManager from "../../../../manager/scene_manager";

@ccclass
@moduleInit('MailModule')
export default class MailModule extends ModuleBase<MailView, null> {


    constructor() {
        super();
        this.layer = ViewLayer.High;
        this.windowPrefabResPath = "package/hall/module/mail/hall_mail";
        this.viewType = MailView;
        this.needAnim = true
        this.autoShowAnim = true
        this.needViewMask = true
        this.needViewBaseBg = true
        this.needViewBaseCloseBtn = true
        this.needViewBaseTitleBg = true
        this.needDeferShow = true
        
        if(this.m_isTest){
            this.tmpList = []        
            for (let index = 0; index < 50; index++) {
                let data = {
                    attachStatus: 1,
                    attachs:[
                        {
                            num: 100,
                            type: 5,
                        }
                    ],
                    content: '测试' + index,
                    title: '这是标题' + index,
                    mailId: index,
                    status: 1,
                    createShowTime:'这是时间' + index,
                }
                this.tmpList.push(data)
            }
        }        
    }
    tmpList: any

    dataList: any
    private m_isTest: boolean = false
    protected m_selectedMailData: any = null
    protected m_selectedMailIndex: number = -1

    onInit(intentData: any) {
        super.onInit(intentData);
        this.bindUiEvent()
        this.bindEvent()
    }

    onDeferShow(intentData) {
        let self = this;
        this.get_mail_data(function (dataList) {
            self.dataList = dataList
            if (intentData != 'tips') {
                if (!self || !self.isValid || !self.view || !self.view.isValid) {
                    return
                }

                self.view.showMailPanel(dataList.length > 0, dataList)
                self.view.showEmptyPanel(dataList.length == 0)                
                self.show()
            }
        })
    }

    onDestroy() {
        this.unbindEvent()
    }

    private bindUiEvent() {
    }

    private bindEvent() {
        this.eventBind('select_mail_item', this.on_click_mail_open_btn)
    }

    private unbindEvent() {
        this.eventUnBind('select_mail_item', this.on_click_mail_open_btn)
    }

    @bindButtonClickEvent("ButtonGetAllAttach")
    private on_click_get_all_attachs(){
        let self = this
        let list = this.dataList
        if(!list){
            return
        }
        let mailIds = []
        let tmpMailDataList = []
        for (let index = 0; index < list.length; index++) {
            const data = list[index];
            if(data.attachs && data.attachs.length > 0 && data.attachStatus == 1){
                mailIds.push(data.mailId)
                tmpMailDataList.push(data)
            }
        }
        if(mailIds.length > 0){
            self.get_mail_award(mailIds, function(retData){
                for (let index = 0; index < tmpMailDataList.length; index++) {
                    const element = tmpMailDataList[index];
                    element.attachStatus = 2
                    element.status = 2
                    self.view.refreshMailItem(element, element._index)
                }
                self.view.refreshGetAllAttachBtn()
                if(self.m_selectedMailIndex >= 0){
                    self.view.refreshDetailPanel(self.m_selectedMailData)
                }
                self.getSelfCurrencyData(null, true)
            })
        }
    }

    @bindButtonClickEvent("ButtonGetAttach")
    private on_click_detail_lingqu_btn() {
        let self = this
        if (!Utility.btnClickValid()) {
            return
        }
        let data = self.m_selectedMailData
        let index = self.m_selectedMailIndex
        this.get_mail_award([data.mailId], function(retData){
            data.attachStatus = 2
            self.view.refreshGetAllAttachBtn()
            if(self.m_selectedMailIndex >= 0){
                self.view.refreshDetailPanel(self.m_selectedMailData)
            }
            self.view.refreshMailItem(data, data._index)
            self.getSelfCurrencyData(null, true)                        
        })
    }

    @bindButtonClickEvent("ButtonDelete")
    private on_click_detail_delete_btn() {
        let self = this
        if (!Utility.btnClickValid()) {
            return
        }
        let data = self.m_selectedMailData
        let index = self.m_selectedMailIndex
        this._delete_mail(data.mailId, function(retData){
            for (let index = 0; index < self.dataList.length; index++) {
                const element = self.dataList[index];
                if(element.mailId == data.mailId){
                    self.dataList.splice(index, 1)
                }
            }
            self.view.showMailPanel(self.dataList.length > 0, self.dataList) 
            self.view.showEmptyPanel(self.dataList.length == 0)                
        }, function(err){

        })
    }

    @bindButtonClickEvent('link')
    protected on_click_link_btn(){
        let self = this
        if (!Utility.btnClickValid()) {
            return
        }
        let data = self.m_selectedMailData
        if(!data){
            return
        }
        let url = data.customeAppField
        if(!url){
            return
        }
        SceneManager.gotoLink(url)
    }

    private on_click_mail_open_btn(data, index) {
        let self = this
        self.m_selectedMailData = data
        self.m_selectedMailIndex = index
        if(data.status == 1){
            this.read_mail(data.mailId, function(){
                data.status = 2
                self.view.refreshMailItem(data, data._index)
            })
        }        
    }

    private get_mail_data(onFinish) {
        let self = this
        if(this.m_isTest){
            onFinish(self.tmpList)
            return
        }        
        self._get_mail_data((data) => {
            self.dataList = data
            if (onFinish) {
                onFinish(data)
            }
        }, () => {
            if (self && self.node) {
                self.showNetPrompt(false)
                self.node.active = false
            }
        })
    }

    private get_mail_award(mailIds: number[], callback) {
        let self = this
        if(this.m_isTest){
            let retDat = {
                data:[
                    
                ]
            }
    
            for (let index = 0; index < this.tmpList.length; index++) {
                const element = this.tmpList[index];
                if(mailIds.indexOf(element.mailId) >= 0){
                    retDat.data.push(element.attachs[0])
                }
            }
            callback(retDat)
            return
        }
        
        let requestData = {
            baseUrl: 'mail/batchReceiveAttachs?',
            showModuleNetprompt: true,
            params: {
                mailIds: mailIds,
            }
        }
        this.apiHttpGet(requestData, (retData) => {
            ModuleManager.instance.hideModule("NetPrompt")
            if(retData.data){
                ModuleManager.instance.showModuleName('DialogReceive', retData.data)
            }
            callback && callback(retData)       
        })
    }

    private read_mail(mailId, callback) {
        if(this.m_isTest){
            callback()
            return
        }
      
        let requestData = {
            baseUrl: 'mail/read?',
            showModuleNetprompt: false,
            params: {
                mailId: mailId,
            }
        }
        this.apiHttpGet(requestData, (retData) => {
            callback && callback()
        })
    }

    onHide(){
        super.onHide()
        let dataList = this.dataList
        if(dataList){
            let hasAttach = false
            for (let index = 0; index < dataList.length; index++) {
                const data = dataList[index];
                if(data.attachs && data.attachs.length > 0 && data.attachStatus == 1){
                    hasAttach = true
                    break
                }
            }            
            !hasAttach && this.eventDispatch('Event_Notify_RedPoint')
        }        
    }

    _get_mail_data(success: Function, fail: Function) {
        let requestData = {
            baseUrl: 'mail/getMailList?',
        }
        this.apiHttpGet(requestData, function (retData) {
            success(retData.data)
        }, (retData) => {
            fail(retData)
            ModuleManager.instance.toast500error(retData)
        })
    }

    _delete_mail(mailId: number, success: Function, fail: Function){
        let requestData = {
            baseUrl: 'mail/delete?',
            params: {
                mailId: mailId,
                gameUserId: ModelData.instance.roleData.id,
            }
        }
        this.apiHttpGet(requestData, function (retData) {
            success(retData.data)
        }, (retData) => {
            fail(retData)
            ModuleManager.instance.toast500error(retData)
        })
    }
}
